import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserContext, VendorContext } from './context';

// When React mounts, remove the shell
window.__hideKadhrShell?.();

// Get auth states from localStorage
const checkCustomer = localStorage.getItem('customer_login');
const checkVendor = localStorage.getItem('vendor_login');

// Mount React root
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <UserContext.Provider value={checkCustomer}>
      <VendorContext.Provider value={checkVendor}>
        <App />
      </VendorContext.Provider>
    </UserContext.Provider>
  </Router>
);

// Performance reporting
reportWebVitals();
